export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10125.a23098e4.jpg";